import { useQuery } from '@tanstack/react-query';
import { diagnosticService } from '../services';

export function useDiagnosticSummary() {
  return useQuery({
    queryKey: ['diagnostic', 'summary'],
    queryFn: () => diagnosticService.getSummary(),
  });
}
